export const RequestHistoryType = {
  lineManager: "Line Manager",
  financeManager: "Finance approver",
  contactEmail: "Contact email",
  contactMobile: "Contact mobile",
};

export const isNullOrEmpty = (value) =>
  value === "" ||
  value === undefined ||
  value === " " ||
  value?.length === 0 ||
  value === null;

export const remiderReceiver = (status) => {
  let receiver;
  switch (status) {
    case "Form requested":
    case "Send back by requestor":
    case "Reopen":
      receiver = "vendor";
      break;
    case "Validated by requestor":
      receiver = "line manager";
      break;
    case "Approved by line manager":
      receiver = "finance";
      break;
    default:
      break;
  }
  return receiver;
};

export const accountStatus = [
  "Form requested",
  "Form submitted",
  "Form resubmitted",
  "Send back by requestor",
  "Validated by requestor",
  "Approved by line manager",
];
